/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { CSSTransition } from 'react-css-transition'
import TransitionStyles from '../../lib/transitionStyles'
import Textbox from '../Textbox'
import AgeCategorySelector from '../AgeCategorySelector'
import PassTypesSelector from '../PassTypesSelector'
import CheckboxWithHelp from './CheckboxWithHelp'
import InstructionIcon from '../../icons/instructionIcon'
import EquipmentIcon from '../../icons/equipmentIcon'
import Button from '../Button'
import Utils, { skuPrice, getSkuPrice, getProductFrom, isHourly } from '../../lib/utils'

export default function PersonExpandedBlock({
  personIndex,
  checkingVoucher,
  clearBookingAttr,
  showInvitation,
  onChange,
  addInvite,
  onChangeByName,
  booking,
  person,
  skus,
  openPriceModal,
  // hasInstruction,
  hasRental,
  openInsuranceCancellationModal,
  openReplacementCardModal,
  // openInstructionModal,
  openRentalModal,
  personErrors
}) {

  const isUpgradeable = person.membership && isHourly(person.membership.type)
  const showAgeSelector = (!person.membership || person.showMembershipBlock)
  const upgradeSelected = Utils.upgradeSelected(person)

  return (
    <>
      {personIndex !== 0 && !booking.invitation && !person.participantId && (
        <>
          <h5 className="text-sky mt-5">
            <FormattedMessage id='booking.person.labelPassType' defaultMessage='Choose reservation type' />
          </h5>
          <div className="w-full flex border rounded-full text-sm text-grey-dark">
            <button onClick={() => clearBookingAttr('invite')} type="button" className={`${!person.invite ? 'text-white bg-sky' : 'text-grey-dark hover:text-blue-darkest'} w-1/2 border border-white py-3 rounded-full font-bold focus:outline-none`}>
              <FormattedMessage id='booking.person.selectPassType' defaultMessage='Select pass' />
            </button>
            <button type="button" onClick={() => showInvitation(personIndex)} className={`${person.invite ? 'text-white bg-sky' : 'text-grey-dark hover:text-blue-darkest'} w-1/2 border border-white py-3 rounded-full font-bold focus:outline-none`}>
              <FormattedMessage id='booking.person.selectInvite' defaultMessage='Invite person' />
            </button>
          </div>
        </>
      )}

      {person.invite && (
        <CSSTransition {...TransitionStyles} transitionAppear active>
          <div className="flex justify-end">
            <div className="flex flex-col w-full md:w-1/2">
              <p className="text-xs text-grey-darker mt-4">
                {
                  /* Save a spot for your friends, and invite them to join you.&nbsp; */
                }
                Reservér en plads til dine venner, og inviter dem til at tage med dig.&nbsp;
                <strong>
                  {
                    /* They pay for themselves when they accept the invitation */
                  }
                  De betaler selv, når de accepterer din invitation
                </strong>
              </p>
              <label htmlFor="inviteEmail" className="text-sky text-sm font-bold mt-4">
                E-mail
                <Textbox
                  type="email" 
                  onChange={onChange} 
                  htmlId="inviteEmail" 
                  htmlName="inviteEmail" 
                  value={person.inviteEmail} 
                  className="w-full"
                  valid={personErrors ? !personErrors.inviteEmail : true}
                />
              </label>               

              <label htmlFor="inviteNote" className="text-sky text-sm font-bold mt-4">
                Note
                <textarea
                  onChange={onChange}
                  id="inviteNote"
                  name="inviteNote"
                  value={person.inviteNote}
                  rows={4}
                  style={{ borderRadius: '1.5rem' }}
                  className="px-4 py-3 text-sm w-full border focus:border-blue-darkest hover:border-blue-darkest text-harbor"
                />
              </label>

              <div className="text-right">
                <Button 
                  onClick={() => addInvite(person.inviteEmail, person.inviteNote)} 
                  bgCss="bg-grass"
                  sizeName="sm"
                  type="button"
                  className="mt-4"
                  disabled={!person.inviteEmail || !Utils.validateEmail(person.inviteEmail) || !person.firstName || !person.lastName}
                >
                  <FormattedMessage id="booking.person.invite" defaultMessage="Invite" />
                </Button>
              </div>
            </div>
          </div>
        </CSSTransition>
      )}

      {!person.invite && (
        <div className="flex flex-wrap mt-2">
          
          <div className={(isUpgradeable || showAgeSelector) && "w-full md:w-1/2"}>
            {isUpgradeable && (
              <div className="text-center md:text-left">
                <Button
                  onClick={() => onChangeByName('showMembershipBlock', !person.showMembershipBlock)}
                  className="mt-5 md:mt-10"
                  bgCss={upgradeSelected ? "bg-grass" : "bg-grey"}
                >
                  <FormattedMessage id='booking.person.toggleMembershipBlock' defaultMessage="Upgrade membership?" />
                </Button>
              </div>
            )}

            {showAgeSelector && (
              <>
                <h5 className="text-sky mt-5">
                  <FormattedMessage id='booking.person.labelAge' defaultMessage='Select age' />
                </h5>
                <AgeCategorySelector 
                  ageCategory={person.ageCategory || (person.membership && person.membership.ageCategory)} 
                  onSelect={onChangeByName}
                  personErrors={personErrors}
                />
              </>
            )}
          </div>
          <div className="w-full md:w-1/2">
            <h5 className="text-sky mt-5">
              <FormattedMessage id='booking.person.labelVoucher' defaultMessage='Got a voucher?' />
            </h5>
            <Textbox
              htmlId="voucher"
              htmlName="voucher"
              onChange={onChange}
              value={person.voucher && person.voucher.trim()}
              placeholderI18n="booking.person.voucher"
              placeholder="Enter voucher"
              className="w-1/2 md:w-auto py-5"
            />
            {checkingVoucher && (
              <div className="text-grey text-xs absolute">
                Checking voucher...
              </div>
            )}
            {(person.appliedVoucher || person.couponInfo) && (
              <div className="text-grass text-xs">
                Voucher OK
              </div>
            )}
          </div>
        </div>
      )}

      {((person.ageCategory && !person.membership)
        || (person.membership && person.membership.ageCategory && person.showMembershipBlock)
      ) && !person.invite && (
        <CSSTransition {...TransitionStyles} transitionAppear active>
          <h5 className="text-sky mt-6">
            <FormattedMessage
              id='booking.person.labelPassType'
              defaultMessage='Select pass'
            />
          </h5>
          <PassTypesSelector
            ageCategory={person.ageCategory || (person.membership && person.membership.ageCategory)}
            passType={person.passType || (person.membership && person.membership.type)}
            skus={skus}
            onSelect={onChangeByName}
            openPriceModal={openPriceModal}
            personErrors={personErrors}
          />
        </CSSTransition>

      )}

      {!person.invite && (person.passType || person.membership) && (
        <CSSTransition {...TransitionStyles} transitionAppear active>
          <div className="p-6 mt-6 shadow-md">
            <h5 className="text-sky uppercase">
              <FormattedMessage id='booking.person.labelExtras' defaultMessage='Choose extras' />
            </h5>
            <div className="flex flex-wrap sm:flex-no-nowrap sm: mt-8">
              <CheckboxWithHelp
                onClick={() => onChangeByName('insuranceCancellation', !person.insuranceCancellation)}
                helpOnClick={openInsuranceCancellationModal}
                checked={person.insuranceCancellation}
                wrapperClassName="sm:w-1/2"
              >
                <div className="font-bold">
                  <FormattedMessage
                    id='booking.person.insuranceCancellation'
                    defaultMessage='Cancellation insurance'
                  />
                </div>
                &nbsp;+&nbsp;
                {skuPrice(getProductFrom('insurance'), 'cancellationSkuId', skus)}
                &nbsp;DKK.
              </CheckboxWithHelp>

              {person.membership && (
                <CheckboxWithHelp
                  onClick={() => onChangeByName('replacementCard', !person.replacementCard)}
                  helpOnClick={openReplacementCardModal}
                  checked={person.replacementCard}
                  wrapperClassName="sm:w-1/2 mt-6 sm:mt-0"
                  labelClassName="flex-wrap"
                  disabled={person.membership.passLost}
                >
                  <div className="flex">
                    <div className="font-bold">
                      <FormattedMessage id='booking.person.replacementCard' defaultMessage='Replacement card' />
                    </div>
                    <div>
                      &nbsp;+&nbsp;
                      {getSkuPrice('misc', 'replacementCardSkuId', skus)}
                      &nbsp;DKK.
                    </div>
                  </div>
                  {person.membership.passLost && (
                    <div
                      style={{ marginLeft: '3.5rem' }}
                      className="text-harbor text-xs font-bold"
                    >
                      <FormattedMessage id='booking.person.replacementCard.alreadyOrdered' defaultMessage='Already ordered' />
                    </div>
                  )}
                </CheckboxWithHelp>
              )}
            </div>

            <div className="flex text-grey-dark mt-8 text-harbor text-sm">
              {/* <div className="w-1/3 text-sm"> */}
              <div className="w-1/2">
                <div className="flex flex-col h-full pr-8">
                  <div className="flex flex-col sm:flex-row flex-grow">
                    <div className="w-10 h-10 mr-4 self-center sm:self-start mb-4">
                      <EquipmentIcon sizeCss="w-10 h-10" textCss="text-harbor" />
                    </div>
                    <div className="leading-tight">
                      <div className="font-bold mb-2">
                        <FormattedMessage
                          id='booking.person.rentalEquipment'
                          defaultMessage='Rental equipment'
                        />
                      </div>
                      <FormattedMessage
                        id='booking.person.rentalEquipmentLn2'
                        defaultMessage='We got it all'
                      />
                    </div>
                  </div>
                  <button
                    type="button"
                    onClick={openRentalModal}
                    className={`${hasRental && 'bg-grass'} w-full bg-sky rounded-full text-aluminium text-xs font-bold py-2 mt-4`}
                  >
                    {hasRental ? (
                      <div>
                        <svg className="fill-current h-3 w-3 text-aluminium" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                          <polygon points="0 11 2 9 7 14 18 3 20 5 7 18" />
                        </svg>
                        &nbsp;&nbsp;
                        <FormattedMessage
                          id='booking.person.added'
                          defaultMessage='Added'
                        />
                      </div>
                    ) : (
                      <div>
                        +&nbsp;&nbsp;
                        <FormattedMessage
                          id='booking.person.add'
                          defaultMessage='Add'
                        />
                      </div>
                    )}
                  </button>
                </div>
              </div>

              <div className="w-1/2">
                <div className="flex flex-col h-full">
                  <div className="flex flex-col sm:flex-row flex-grow">
                    <div className="w-10 h-10 mr-4 self-center sm:self-start mb-4">
                      <InstructionIcon sizeCss="w-10 h-10" textCss="text-harbor" />
                    </div>
                    <div className="leading-tight">
                      <div className="font-bold mb-2">
                        <FormattedMessage
                          id='booking.person.skiInstruction'
                          defaultMessage='Ski instructor'
                        />
                      </div>
                      <FormattedMessage
                        id='booking.person.skiInstructionLn2'
                        defaultMessage='Private or team skiing lessons'
                      />
                    </div>
                  </div>
                  {/* <button
                    type="button"
                    onClick={openInstructionModal}
                    className={`${hasInstruction ? 'bg-grass' : 'bg-sky'} w-full rounded-full text-aluminium text-xs font-bold py-2 mt-4`}
                  >
                    {hasInstruction ? (
                      <div>
                        <svg className="fill-current h-3 w-3 text-aluminium" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                          <polygon points="0 11 2 9 7 14 18 3 20 5 7 18" />
                        </svg>
                        &nbsp;&nbsp;
                        <FormattedMessage
                          id='booking.person.added'
                          defaultMessage='Added'
                        />
                      </div>
                    ) : (
                      <div>
                        +&nbsp;&nbsp;
                        <FormattedMessage
                          id='booking.person.add'
                          defaultMessage='Add'
                        />
                      </div>
                    )}
                  </button> */}
                </div>
              </div>

              {/* <div className="w-1/3 text-sm"> */}

              {/* <div className="w-1/3 text-sm">
                      <div className="flex flex-col h-full pl-4">
                        <div className="flex flex-grow">                    
                          <div className="rounded-full w-10 h-10 border mr-4">
                            &nbsp;
                          </div>
                          <div className="leading-tight">
                            <div className="font-bold mb-2">
                              <FormattedMessage
                                id='booking.person.meal'
                                defaultMessage='Value meal'
                              />
                            </div>
                            <FormattedMessage
                              id='booking.person.mealLn2'
                              defaultMessage='Don&apos;t go hungry'
                            />
                          </div>
                        </div>
                        <button
                          type="button"
                          className="w-full bg-sky rounded-full text-aluminium text-xs font-bold py-2 mt-4"
                        >
                          <div>
                            +&nbsp;&nbsp;
                            <FormattedMessage
                              id='booking.person.add'
                              defaultMessage='Add'
                            />
                          </div>
                        </button>
                      </div>
                    </div> */}
            </div>
          </div>
        </CSSTransition>
      )}

    </>
  )
}
  